// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { getUser } from "../services/profile.service";

// Lets the sidebar kick off the GET_USER call on hover-intent, before the user
// actually clicks into the profile page, so the data is already in flight (or
// already resolved) by the time ProfileLayout mounts and asks for it.
let pendingUserFetch = null;

export function prefetchUserProfile() {
  if (!pendingUserFetch) {
    pendingUserFetch = getUser().catch((err) => {
      pendingUserFetch = null;
      throw err;
    });
  }
  return pendingUserFetch;
}

export function getUserProfile() {
  return prefetchUserProfile();
}

export function clearUserProfileCache() {
  pendingUserFetch = null;
}
